import type { TranslationKey } from './keys';
import type { useTranslation } from './index';

const AUTH_ERROR_KEYS: Record<string, TranslationKey> = {
  rate_limited: 'auth.error.rateLimited',
  invalid_credentials: 'auth.error.invalidCredentials',
  network: 'auth.error.network',
  unavailable: 'auth.error.unavailable',
  generic: 'auth.error.generic',
};

/**
 * Turns what an auth thunk rejected with (see `authRejection`) into text: the
 * known codes are translated, any other string is the server's own message
 * (for example which field failed validation) and is shown as it is.
 */
export function translateAuthError(
  t: ReturnType<typeof useTranslation>['t'],
  error: string
): string {
  const key = AUTH_ERROR_KEYS[error];
  return key ? t(key) : error;
}
